import React from 'react';
// import styled from "styled-components";

// function fadeOut(element: any) {
//     if (!element) return;
//     let op = 1; // initial opacity
//     const timer = setInterval(function() {
//         if (op <= 0) {
//             clearInterval(timer);
//         }
//         element.style.opacity = op;
//         op -= 0.5;
//     }, 400);
// }

interface IScreenProps {
  isPaused: boolean;
}

/**
 * 플레이어 / 화면 컴포넌트
 */
const Screen = ({isPaused}: IScreenProps) => {
  // useEffect(() => {
  //     const timer = setTimeout(() => {
  //         const centerBtn = document.getElementById("centerBtn");
  //         if (centerBtn) {
  //             centerBtn.style.display = "none";
  //         }
  //     }, 400);

  //     return () => {
  //         clearTimeout(timer);
  //     };
  // }, [isPaused]);

  const playPaused = {
    cssClass: 'btn_cneter_pause',
    text: 'PLAY',
    display: 'block',
  };

  if (isPaused) {
    playPaused.cssClass = 'btn_cneter_play';
    playPaused.text = 'PAUSE';
    playPaused.display = 'block';
  }

  return (
    <>
      <div className='center_btn' id='centerBtn' style={{display: 'none'}}>
        <button type='button' className={playPaused.cssClass}>
          <span>{playPaused.text}</span>
        </button>
        {/* <div className="fast_forward">
                    <span></span>
                    <em>30</em>
                </div>
                <div className="rewind">
                    <span></span>
                    <em>30</em>
                </div> */}
      </div>
      {/* <div className="loading">
                <span></span>
            </div> */}
      {/* <div className="buffering">
                <span></span>
            </div> */}
    </>
  );
};

export default React.memo(Screen);
